import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { DetailFormBase } from '../../FormBases';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  error: FieldError | undefined;
};

/**
 * 新規登録モーダル用の顧客詳細のフォームです。
 */
export const DetailForm: FC<Props> = ({ register, error }) => (
  <FormControl isRequired isInvalid={Boolean(error)}>
    <FormLabel>顧客詳細</FormLabel>
    <DetailFormBase register={register} />
    <FormErrorMessage>{error && error.message}</FormErrorMessage>
  </FormControl>
);
